<template>
    <div class="home-frame-container">
        <div class="home-view">
            <router-view></router-view>
        </div>

        <div class="home-footer" :class="{'no-bottom-bar':frame.hideBottomBar}">
            <div class="footer-item" :class="{active: _iconActive[0]}" @click="goRouter(0)">
                <span class="text">首页</span>
                <img v-if="_iconActive[0]" class="icon" src="../../assets/home/home_active.jpg">
                <img v-else class="icon" src="../../assets/home/home_icon.jpg">
            </div>

            <div class="footer-item" :class="{active: _iconActive[1]}" @click="goRouter(1)">
                <span class="text">我的</span>
                <img v-if="_iconActive[1]" class="icon" src="../../assets/home/mine_active.jpg">
                <img v-else class="icon" src="../../assets/home/mine_icon.jpg">
            </div>
        </div>
    </div>
</template>
<script setup>
import {computed, getCurrentInstance, onMounted, reactive, provide} from "vue";

const {proxy} = getCurrentInstance()
const _iconActive = computed(()=> {
    var path = proxy.$route.path.toLowerCase()
    return [path==='/home', path==='/mine']
})

const frame = reactive({
    hideBottomBar: false,
})
provide("frame", frame)

const goRouter = (index)=>
{
    if(index==0) {
        proxy.$router.push("home")
    }else if(index==1) {
        proxy.$router.push("mine")
    }
}

onMounted(()=>{
    let smsg = sessionStorage.getItem("session-msg")
    if(smsg) {
        proxy.$toast.success(smsg)
        sessionStorage.removeItem("session-msg")
        console.log("session-msg="+smsg)
    }
})
</script>
<style lang="scss" scoped>
.home-frame-container{
    height: 100vh;
    display: flex;
    flex-direction: column;
}

.home-view {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 58px;
}

.home-footer
{
    height: 55px;
    border-top: 1px solid #eee;
    display: flex;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background: #fff;
    font-size: 12px;
    z-index: 1888;  //这个zindex不能太大，必须小于 van-overlay 的 2003

    &.no-bottom-bar {
        display: none;
    }

    .footer-item {
        flex: 1;
        height: 100%;
        max-width: 49%;
        display: flex;
        flex-direction: column-reverse;
        justify-content: flex-start;
        align-items: center;
        padding: 5px;
        box-sizing: border-box;
        color: #666666;
        &:active{
            background: #f5f5f5;
        }
        &.active{
            .text{
                color: $theme
            }
        }
        .icon{
            width: 30px;
            height: 30px;
            padding: 3px;
            box-sizing: border-box;
        }
        .text{
            font-size: 12px;
        }
    }

    .footer-item-center  {
        @extend .footer-item;
        max-width: 24%;
    }
}
</style>